//LOGIN
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGOUT_USER = "LOGOUT_USER";

//SWITCH ACCOUNT
export const SWITCH_SUCCESS = "SWITCH_SUCCESS";
export const SWITCH_FAILURE = "SWITCH_FAILURE";
// export const CREATE_ACCOUNT = "CREATE_ACCOUNT"

// ERROR
export const SET_ERROR = "SET_ERROR";
export const SET_LOGIN_ERROR = "SET_LOGIN_ERROR";
export const SET_SIGNUP_ERROR = "SET_SIGNUP_ERROR";
export const CLEAR_ERROR = "CLEAR_ERROR";
export const SET_SWITCH_ERROR = "SET_SWITCH_ERROR";

//USER
export const UPDATE_USER_DETAILS = "UPDATE_USER_DETAILS";
export const UPDATE_USER_SETTINGS = "UPDATE_USER_SETTINGS";
export const UPDATE_USER_PROFILE = "UPDATE_USER_PROFILE";

//Account
export const SET_ACCOUNT = "SET_ACCOUNT";
export const SET_INVOICE_FLAG_SUCCESS_MESSAGE = "SET_INVOICE_FLAG_SUCCESS_MESSAGE";
export const SET_INVOICE_FLAG_ERROR_MESSAGE = "SET_INVOICE_FLAG_ERROR_MESSAGE";

// RESET PASSWORD
export const SET_RESET_PASSWORD_USER_DETAILS = "SET_RESET_PASSWORD_USER_DETAILS";

//ORGANIZATION
export const SET_ORGANIZATION = "SET_ORGANIZATION";

//CURRENCIES
export const SET_CURRENCIES = "SET_CURRENCIES";

//ALERT
export const CREATE_ALERT = "CREATE_ALERT";

//LOADING
export const UPDATE_LOADING = "UPDATE_LOADING";

//PROJECTS
export const SET_ALL_PROJECT = "SET_ALL_PROJECT";
export const SET_PROJECT_BY_ID = "SET_PROJECT_BY_ID";
export const SET_MAPPER = "SET_MAPPER";
export const SET_PROJECT_SETUP_STATE = "SET_PROJECT_SETUP_STATE";
export const UPDATE_SELECTED_PROJECT = "UPDATE_SELECTED_PROJECT";
export const SET_PROJECT_COST = "SET_PROJECT_COST";
export const SET_ALL_CREDENTIAL = "SET_ALL_CREDENTIAL";
export const SET_ALL_IP_ACCESS = "SET_ALL_IP_ACCESS";
export const SET_TRAIN_TASKS = "SET_TRAIN_TASKS";
export const SET_PREVIOUSLY_SETUP_STATE = "SET_PREVIOUSLY_SETUP_STATE";
export const SET_PROJECT_COUNTS = "SET_PROJECT_COUNTS";
export const SET_MAIRA_OPTIONS = "SET_MAIRA_OPTIONS";
export const SET_CATALOG_ITEMS = "SET_CATALOG_ITEMS";
export const CATALOG_SCROLL_ID_STACK = "CATALOG_SCROLL_ID_STACK";

//EMAIL CONFIG
export const SET_EMAIL_CONFIGS = "SET_EMAIL_CONFIGS";
export const SET_EMAIL_PROVIDERS = "SET_EMAIL_PROVIDERS";
export const SET_EMAIL_RECIPIENTS = "SET_EMAIL_RECIPIENTS";
export const SET_EMAIL_TEMPLATES = "SET_EMAIL_TEMPLATES";

//GPT PROFILE
export const SET_GPT_PROFILES = "SET_GPT_PROFILES";
export const SET_GPT_PROFILE = "SET_GPT_PROFILE";
export const SET_GPT_SETUP_STATE = "SET_GPT_SETUP_STATE";
export const SET_BROADCASTS_MESSAGE = "SET_BROADCASTS_MESSAGE";
export const SET_SHAREABLE_DATA = "SET_SHAREABLE_DATA";
export const SET_DEFAULT_CATEGORIES = "SET_DEFAULT_CATEGORIES";
export const SET_ENCRYPT_RESPONSE = "SET_ENCRYPT_RESPONSE";

//GPT DATASET
export const SET_GPT_DATASETS = "SET_GPT_DATASETS";
export const SET_GPT_DATASET = "SET_GPT_DATASET";
export const SET_GPT_DATASET_SUMMARY = "SET_GPT_DATASET_SUMMARY";
export const SET_COUNTRY_LIST = "SET_COUNTRY_LIST";

//GPT DOCUMENT
export const SET_GPT_DOCUMENTS = "SET_GPT_DOCUMENTS";
export const SET_GPT_DOCUMENT = "SET_GPT_DOCUMENT";
export const SET_GPT_DOCUMENT_SUMMARY = "SET_GPT_DOCUMENT_SUMMARY";

//GPT Conversations
export const SET_GPT_CONVERSATIONS = "SET_GPT_CONVERSATIONS";

// RECOMMENDER
export const RECOMMENDER_SET_INSIGHTS = "RECOMMENDER_SET_INSIGHTS";

//SOLUTIONS
export const SET_ALL_SOLUTION = "SET_ALL_SOLUTION";
export const SET_ALL_SOLUTION_BY_TYPE = "SET_ALL_SOLUTION_BY_TYPE";
export const SET_SOLUTION_BY_ID = "SET_SOLUTION_BY_ID";
export const SET_RELATED_SOLUTIONS_BY_TYPE = "SET_RELATED_SOLUTIONS_BY_TYPE";
export const SET_ALL_SOLUTION_BY_DEV = "SET_ALL_SOLUTION_BY_DEV";
export const SET_PUBLIC_SOLUTIONS = "SET_PUBLIC_SOLUTIONS";
export const SET_SOLUTION_DETAILS = "SET_SOLUTION_DETAILS";
export const SET_SOLUTION_HAS_PROJECT = "SET_SOLUTION_HAS_PROJECT";

//RESOURCEMETADATA
export const SET_ALL_RESOURCEMETADATA = "SET_ALL_RESOURCEMETADATA";
export const SET_ALL_RESOURCEMETADATA_BY_TYPE = "SET_ALL_RESOURCEMETADATA_BY_TYPE";

//CATEGORY
export const SET_ALL_CATEGORY = "SET_ALL_CATEGORY";

// SUBSCRIPTION
export const SET_ALL_SUBSCRIPTION = "SET_ALL_SUBSCRIPTION";

// INVOICE
export const SET_ALL_INVOICE = "SET_ALL_INVOICE";
export const SET_INVOICE_BY_ID = "SET_INVOICE_BY_ID";

// SEGMENT
export const SET_ALL_SEGMENT = "SET_ALL_SEGMENT";

// WALLET
export const SET_ALL_WALLET_ACCOUNT = "SET_ALL_WALLET_ACCOUNT";
export const SET_ALL_WALLET_TRANSACTION = "SET_ALL_WALLET_TRANSACTION";
export const SET_WALLET_ACCOUNT_DETAILS = "SET_WALLET_ACCOUNT_DETAILS";
export const SET_ALL_WALLET_CLAIMABLE_BALANCE = "SET_ALL_WALLET_CLAIMABLE_BALANCE";
export const SET_ALL_WALLET_RECIEVED_CLAIMABLE_BALANCE = "SET_ALL_WALLET_RECIEVED_CLAIMABLE_BALANCE";
export const SET_WALLET_STELLAR_TRANSACTION = "SET_WALLET_STELLAR_TRANSACTION";
export const SET_WALLET_SELECTED_ACC = "SET_WALLET_SELECTED_ACC";
export const SET_WALLET_BUY_HISTORY_BY_ACCOUNT = "SET_WALLET_BUY_HISTORY_BY_ACCOUNT";
export const SET_ALL_WALLET_ASSET = "SET_ALL_WALLET_ASSET";

// UPLOAD
export const SET_ALL_CONTENT = "SET_ALL_CONTENT";
export const SET_CONTENT = "SET_CONTENT";

// BANK
export const SET_ALL_BANK_ACCOUNT = "SET_ALL_BANK_ACCOUNT";
export const SET_BANK_ACCOUNT_BY_ID = "SET_BANK_ACCOUNT_BY_ID";

// REGION
export const SET_ALL_REGION = "SET_ALL_REGION";
export const SET_REGION_BY_ID = "SET_REGION_BY_ID";

// JOBS
export const SET_ALL_JOB = "SET_ALL_JOB";

// MEMBERS
export const SET_ALL_MEMBERS = "SET_ALL_MEMBERS";
export const SET_MEMBER_BY_ID = "SET_MEMBER_BY_ID";
export const SET_SEARCHED_MEMBERS = "SET_SEARCHED_MEMBERS";
export const SET_SELECTED_MEMBER = "SET_SELECTED_MEMBER";
export const SET_SEARCHED_EMAIL = "SET_SEARCHED_EMAIL";

// LOCALE
export const SET_LOCALE = "SET_LOCALE";
export const SET_ACTIVE_CLIENT_KEY = "SET_ACTIVE_CLIENT_KEY";

// ALLOWED IPS
export const SET_ALL_ALLOWED_IPS = "SET_ALL_ALLOWED_IPS";
export const SET_ALLOWED_IP_BY_ID = "SET_ALLOWED_IP_BY_ID";

//GPT MODEl
export const SET_GPT_MODELS = "SET_GPT_MODELS";
export const SET_GPT_PROVIDERS = "SET_GPT_PROVIDERS";

//Set project assigned member list
export const SET_PROJECT_ASSIGNED_MEMBERS = "SET_PROJECT_ASSIGNED_MEMBERS";

// GPT Session
export const GET_GPT_SESSIONS = "GET_GPT_SESSIONS";

//Questionnaire
export const SET_MAIRA_QUESTIONNAIRE = "SET_MAIRA_QUESTIONNAIRE";
export const CLEAR_SELECTED_QUESTIONNAIRE = "CLEAR_SELECTED_QUESTIONNAIRE";

// Notification
export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";
export const SET_NOTIFICATION = "SET_NOTIFICATION";
export const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION";
export const SET_SUPPRESS_BADGE = "SET_SUPPRESS_BADGE";
export const SET_DROPDOWN_NOTIFICATIONS = "SET_DROPDOWN_NOTIFICATIONS";
export const UPDATE_DROPDOWN_NOTIFICATION = "UPDATE_DROPDOWN_NOTIFICATION";
export const SET_LAST_SEEN = "SET_LAST_SEEN";

//Subscription Plans
export const SET_ALL_SUBSCRIPTION_PLANS = "SET_ALL_SUBSCRIPTION_PLANS";
export const SET_SUBSCRIPTION_PLAN_BY_ID = "SET_SUBSCRIPTION_PLAN_BY_ID";
export const ADD_SUBSCRIPTION_PLAN = "ADD_SUBSCRIPTION_PLAN";
export const REMOVE_SUBSCRIPTION_PLAN = "REMOVE_SUBSCRIPTION_PLAN";
export const SET_SUBSCRIPTION_PLANS_ERROR_MESSAGE = "SET_SUBSCRIPTION_PLANS_ERROR_MESSAGE";
export const SET_SUBSCRIPTION_PLANS_SUCCESS_MESSAGE = "SET_SUBSCRIPTION_PLANS_SUCCESS_MESSAGE";
export const SET_FREE_PLAN_SUCCESS_MESSAGE = "SET_FREE_PLAN_SUCCESS_MESSAGE";
export const SET_FREE_PLAN_ERROR_MESSAGE = "SET_FREE_PLAN_ERROR_MESSAGE";
export const SET_FREE_PLAN_LOADING = "SET_FREE_PLAN_LOADING";
export const SET_FREE_PLAN = "SET_FREE_PLAN";

//Fetch feature access
export const SET_DEFAULT_FEATURE_ACCESS_CONFIG = "SET_DEFAULT_FEATURE_ACCESS_CONFIG";
export const SET_DEFAULT_FEATURE_ACCESS_LOADING = "SET_DEFAULT_FEATURE_ACCESS_LOADING";
export const SET_DEFAULT_FEATURE_ACCESS_ERROR = "SET_DEFAULT_FEATURE_ACCESS_ERROR";
